import classNames from 'classnames';
import { FC } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

import './TeamName.scss';

interface IProps {
  team: ITeam;
  className?: string;
}

const TeamName: FC<IProps> = ({ team, className }) => {
  const { name, isDeactivated, deactivatedAncestorId } = team;
  return (
    <div className={classNames('TeamName', className)}>
      <span>{name || '*NEW TEAM*'}</span>
      {!!(isDeactivated || deactivatedAncestorId) && (
        <OverlayTrigger
          overlay={
            <Popover id={`course-unpublished-tooltip`}>
              <Popover.Content>Deactivated</Popover.Content>
            </Popover>
          }
        >
          <span className="material-icons-outlined pointer unpublished">unpublished</span>
        </OverlayTrigger>
      )}
    </div>
  );
};

export default TeamName;
